import cx from "classnames";
import React from "react";

import styles from "./styles.module.scss";
import _ from "lodash";

interface ContactCardViewToggleProps {
  show: boolean;
  selectedView: string;
  views: any;
  // eslint-disable-next-line no-unused-vars
  onViewSelect: (view: any) => void;
  dimensions?: any;
  width?: any;
  height?: any;
  // eslint-disable-next-line no-unused-vars
  onResize?: (width: number, height: number) => void;
}

const ContactCardViewToggle: React.FC<ContactCardViewToggleProps> = ({
  show,
  selectedView,
  views,
  onViewSelect,
  dimensions = [],
  width = 1,
  height = 1,
  // eslint-disable-next-line no-unused-vars
  onResize = (width: number, height: number) => {},
}) => {
  return (
    <div className={cx(styles.pillContainer, {
      [styles.show]: show,
    })}>
      {_.size(dimensions) > 0 && <div
        className={cx(styles.pill, {
          [styles.show]: show,
        })}
      >
        {dimensions.map((dimension) => {
          const selected =
            dimension.width === width && dimension.height === height;
          return (
            <div
              key={dimension.id}
              className={cx(styles.resize, styles[dimension.id], {
                [styles.selected]: selected,
              })}
              onClick={() => onResize?.(dimension.width, dimension.height)}
            ></div>
          );
        })}
      </div>}
      {_.size(views) > 0 && <div
        className={cx(styles.pill, {
          [styles.show]: show,
        })}
      >
        {views.map((view: any) => {
          const selected = view.type === selectedView;
          return (
            <i
              key={view.id}
              className={cx(styles.icon, view.icon, {
                [styles.selected]: selected,
              })}
              onClick={() => onViewSelect(view.id)}
            />
          );
        })}
      </div>}
    </div>
  );
};

export default ContactCardViewToggle;
